/* eslint-disable */

import "../App.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import AppNavbar from "../components/Navbar.js";
import AppFooter from "../components/Footer.js";

import Vector from "../assets/images/Vector.png";
import Pardna from "../assets/images/padna.svg";
import Padna from "../assets/images/pardna.svg";
import Faces from "../assets/images/faces.svg";
import Persons from "../assets/images/persons.svg";
import Stu from "../assets/images/stu.png";
import Group from "../assets/images/group.png";
import { BsArrowRightCircle } from "react-icons/bs";
import { TypeAnimation } from "react-type-animation";
import styled from "styled-components";
import { StyledImage } from "../components/images.js";
import Accordion from "../components/accordion/accordion.js";
import React, { useState } from "react";
import TestimonialCarousel from '../components/Testimonial';
import axios from "axios";
import { BASE_URL } from '../utils/index';

const FirstViewport = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding-top: var(--navbar-height);
  box-sizing: border-box;
`;

const RoleToggle = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 3px;
  margin: 0 auto 36px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  box-shadow: var(--shadow-xs);
  position: relative;
  z-index: 1;
`;

const TabButton = styled.button`
  font-weight: 600;
  font-size: 0.78rem;
  border: none;
  border-radius: 999px;
  padding: 5px 16px;
  min-height: 32px;
  min-width: 88px;
  cursor: pointer;
  background-color: ${(p) => (p.$active ? "var(--primary-color)" : "transparent")};
  color: ${(p) => (p.$active ? "#fff" : "var(--text-secondary)")};
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  box-shadow: ${(p) => (p.$active ? "var(--shadow-xs)" : "none")};

  &:hover,
  &:focus-visible {
    color: ${(p) => (p.$active ? "#fff" : "var(--primary-color)")};
    background-color: ${(p) => (p.$active ? "var(--primary-color-dark)" : "var(--color-primary-50)")};
  }
`;

const PartnersSection = styled.section`
  width: 100%;
  flex-shrink: 0;
  background: #fcfcfc;
  padding: 48px 16px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h6 {
    font-weight: 700;
    font-size: 1rem;
    margin: 0 0 8px;
    color: var(--text-primary);
  }

  @media (max-width: 768px) {
    padding: 40px 16px 28px;
  }
`;

const PartnersRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
`;

const PartnerLogo = styled.img`
  width: 72px;
  height: auto;
  max-width: 36vw;
  object-fit: contain;
  background: #fff;
  border-radius: 8px;
`;

const BackgroundWrapper = styled.div`
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #fff;
  overflow: hidden;
  padding-top: 48px;
  padding-bottom: 56px;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${Vector});
    background-size: cover;
    background-position: center;
    opacity: 0.85;
    z-index: 0;
  }
`;

const SubHeadText = styled.div`
  font-size: clamp(1rem, 1.1vw + 0.7rem, 1.2rem);
  width: 100%;
  max-width: 640px;
  line-height: 1.55;
  margin: 0 auto 28px;
  padding: 0 8px;
  text-align: center;
  color: var(--text-secondary);

  @media (max-height: 700px) {
    margin-bottom: 16px;
    font-size: 0.98rem;
  }
`;

const FeatureSection = styled(Container)`
  background: ${(p) => p.$bg || "#F4FFF8"};
  padding: 64px 24px;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`;

const FeatureCopy = styled.div`
  text-align: left;

  @media (max-width: 991.98px) {
    text-align: center;

    .feature-cta {
      justify-content: center;
    }
  }
`;

const SectionHeadText = styled.div`
  width: 100%;
  font-size: clamp(1.5rem, 2vw + 0.7rem, 2.15rem);
  font-weight: 800;
  line-height: 1.25;
  color: var(--text-primary);
  padding: 0;
  text-align: inherit;
`;

const SectionBodyText = styled.div`
  font-size: clamp(0.98rem, 0.6vw + 0.8rem, 1.05rem);
  line-height: 1.65;
  font-weight: 400;
  padding: 0;
  text-align: inherit;
  width: 100%;
  color: var(--text-secondary);
`;

const HeroContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 920px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 24px 8px;
  box-sizing: border-box;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0 16px 4px;
  }
`;

const HeroText = styled.div`
  font-size: clamp(2.2rem, 5.2vw + 0.7rem, 4rem);
  font-weight: 800;
  text-align: center;
  width: 100%;
  max-width: 920px;
  line-height: 1.15;
  letter-spacing: -0.025em;
  margin-bottom: 18px;
  color: var(--text-primary);
  overflow-wrap: break-word;

  @media (max-width: 576px) {
    font-size: clamp(1.9rem, 8vw, 2.45rem);
    line-height: 1.2;
    margin-bottom: 14px;
  }

  @media (max-height: 700px) {
    font-size: clamp(1.85rem, 4.5vw, 2.8rem);
    margin-bottom: 12px;
  }
`;

const FaqHeading = styled.h2`
  width: 100%;
  text-align: center;
  font-size: clamp(1.5rem, 2vw + 0.6rem, 2rem);
  font-weight: 800;
  margin: 48px 0 8px;
  color: var(--text-primary);
`;

const NewsletterWrap = styled(Container)`
  padding: 32px 16px 48px;

  @media (min-width: 768px) {
    padding: 48px 24px 64px;
  }
`;

export default function AppHome() {
  const [activeTab, setActiveTab] = useState("learner"); // State to track active tab

  // Newsletter email state
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterSuccess, setNewsletterSuccess] = useState(false);
  const [newsletterError, setNewsletterError] = useState("");

  // Newsletter handler
  const handleNewsletterJoin = async (e) => {
    e.preventDefault();
    setNewsletterError("");
    setNewsletterSuccess(false);

    // Simple email validation
    if (!newsletterEmail || !/\S+@\S+\.\S+/.test(newsletterEmail)) {
      setNewsletterError("Please enter a valid email address.");
      return;
    }

    try {
      await axios.post(`${BASE_URL}/user/email-capture`, { email: newsletterEmail });
      setNewsletterSuccess(true);
      setNewsletterEmail("");
    } catch (err) {
      setNewsletterError("Failed to subscribe. Please try again later.");
    }
  };

  return (
    <>
      <header>
        {/* Nav bar */}
        <AppNavbar />
      </header>

      <main style={{ overflowX: "hidden" }}>
        <FirstViewport>
          <BackgroundWrapper>
            <HeroContainer>
              <RoleToggle role="tablist" aria-label="Choose your role">
                <TabButton
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "learner"}
                  $active={activeTab === "learner"}
                  onClick={() => setActiveTab("learner")}
                >
                  Learner
                </TabButton>
                <TabButton
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "sponsor"}
                  $active={activeTab === "sponsor"}
                  onClick={() => setActiveTab("sponsor")}
                >
                  Sponsor
                </TabButton>
              </RoleToggle>
              {activeTab === "learner" ? (
                <>
                  <HeroText>
                    <span style={{ display: "block" }}>
                      <TypeAnimation
                        key="learner-1"
                        sequence={[
                          "Easily find",
                          2000,
                          "Easily start",
                          2000,
                          "Easily complete",
                          2000,
                        ]}
                        wrapper="span"
                        cursor={false}
                        repeat={Infinity}
                        style={{ color: "var(--text-primary)" }}
                      />
                    </span>
                    <span style={{ display: "block" }}>
                      online courses you need
                    </span>
                    <span style={{ display: "block" }}>
                      {"to "}
                      <TypeAnimation
                        key="learner-2"
                        sequence={["succeed", 2000, "upskill", 2000]}
                        wrapper="span"
                        cursor={false}
                        repeat={Infinity}
                        style={{ display: "inline", color: "var(--text-primary)" }}
                      />
                    </span>
                  </HeroText>
                  <SubHeadText>
                    Whatever you want to learn online, wherever they are hosted.
                    <br />
                    We will help you make the most of the journey.
                  </SubHeadText>
                  <Link to="/user-auth">
                    <Button
                      className="btn-primary-custom btn-lg d-inline-flex justify-content-center align-items-center"
                      style={{
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                        maxWidth: "100%",
                      }}
                    >
                      Get Started
                    </Button>
                  </Link>
                </>
              ) : (
                <>
                  <HeroText>
                    <TypeAnimation
                      key="sponsor-1"
                      sequence={[
                        "Fund a Learner's Journey",
                        2000,
                        "Support a Learner Today",
                        2000,
                      ]}
                      wrapper="span"
                      cursor={false}
                      repeat={Infinity}
                      style={{ color: "var(--text-primary)" }}
                    />
                  </HeroText>
                  <SubHeadText>
                    Sponsor ambitious, underserved youths to pay for online courses
                    they need to succeed.
                  </SubHeadText>
                  <Link to="/help-learner">
                    <Button
                      className="btn-primary-custom btn-lg d-inline-flex justify-content-center align-items-center"
                      style={{
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                        maxWidth: "100%",
                      }}
                    >
                      Sponsor Now
                    </Button>
                  </Link>
                </>
              )}
            </HeroContainer>
          </BackgroundWrapper>

          <PartnersSection>
            <h6>Partners</h6>
            <PartnersRow>
              <a href="https://guardian.ng/technology/three-nigerian-tech-innovators-bag-innovate-uk-ktn-6000-prize/" target="_blank" rel="noopener noreferrer">
                <PartnerLogo src={Pardna} alt="The Guardian" />
              </a>
              <a href="https://www.facebook.com/watch/?v=851862154664298" target="_blank" rel="noopener noreferrer">
                <PartnerLogo src={Padna} alt="Facebook Feature" />
              </a>
            </PartnersRow>
          </PartnersSection>
        </FirstViewport>

        {activeTab === "learner" && (
        <FeatureSection fluid $bg="#F4FFF8">
          <Row className="align-items-center g-4 g-lg-5 mx-auto" style={{ maxWidth: "1140px" }}>
            <Col lg={6} className="order-2 order-lg-1">
              <FeatureCopy>
                <SectionHeadText style={{ marginBottom: "20px" }}>
                  Unlock Your Personalized Learning Journey
                </SectionHeadText>
                <SectionBodyText style={{ marginBottom: "28px" }}>
                  Chat live with Moji to define your career goals, assess your skills,
                  and instantly get matched with the online courses that fit your budget and schedule.
                </SectionBodyText>
                <div className="d-flex align-items-center feature-cta">
                  <a href="/chat" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                    <Button className="btn-primary-custom">
                      Get Started
                    </Button>
                  </a>
                  <BsArrowRightCircle className="spin ms-3" style={{ color: "var(--primary-color)", fontSize: "24px" }} />
                </div>
              </FeatureCopy>
            </Col>
            <Col lg={6} className="order-1 order-lg-2">
              <div className="feature-img-wrapper">
                <img src={Faces} alt="Personalized learning faces" />
              </div>
            </Col>
          </Row>
        </FeatureSection>
        )}

        {activeTab === "sponsor" && (
        <FeatureSection fluid $bg="#F4FFF8">
          <Row className="align-items-center g-4 g-lg-5 mx-auto" style={{ maxWidth: "1140px" }}>
            <Col lg={6}>
              <div className="feature-img-wrapper">
                <img src={Persons} alt="Sponsor learners" />
              </div>
            </Col>
            <Col lg={6}>
              <FeatureCopy>
                <SectionHeadText style={{ marginBottom: "20px" }}>
                  Help a learner pay for online courses they need and can't afford
                </SectionHeadText>
                <SectionBodyText style={{ marginBottom: "28px" }}>
                  Empower motivated individuals by funding their digital education.
                </SectionBodyText>
                <div className="d-flex align-items-center feature-cta">
                  <Link to="/help-learner" style={{ textDecoration: "none" }}>
                    <Button className="btn-primary-custom">
                      Sponsor a learner
                    </Button>
                  </Link>
                  <BsArrowRightCircle className="spin ms-3" style={{ color: "var(--primary-color)", fontSize: "24px" }} />
                </div>
              </FeatureCopy>
            </Col>
          </Row>
        </FeatureSection>
        )}

        {activeTab === "learner" && (
        <FeatureSection fluid $bg="#FFFCF9">
          <Row className="align-items-center g-4 g-lg-5 mx-auto" style={{ maxWidth: "1140px" }}>
            <Col lg={6} className="order-2 order-lg-1">
              <FeatureCopy>
                <SectionHeadText style={{ marginBottom: "20px" }}>
                  Ask for help to pay for courses you need but cannot afford
                </SectionHeadText>
                <SectionBodyText style={{ marginBottom: "28px" }}>
                  Submit your request and get connected with generous sponsors ready to fund your learning path.
                </SectionBodyText>
                <div className="d-flex align-items-center feature-cta">
                  <Link to="/help" style={{ textDecoration: "none" }}>
                    <Button className="btn-primary-custom">
                      Request for help
                    </Button>
                  </Link>
                  <BsArrowRightCircle className="spin ms-3" style={{ color: "var(--primary-color)", fontSize: "24px" }} />
                </div>
              </FeatureCopy>
            </Col>
            <Col lg={6} className="order-1 order-lg-2">
              <div className="feature-img-wrapper">
                <img src={Stu} alt="Student request help" />
              </div>
            </Col>
          </Row>
        </FeatureSection>
        )}

        {activeTab === "learner" && (
        <FeatureSection fluid $bg="#F4FFF8">
          <Row className="align-items-center g-4 g-lg-5 mx-auto" style={{ maxWidth: "1140px" }}>
            <Col lg={6}>
              <div className="feature-img-wrapper">
                <img src={Group} alt="Learner community group" />
              </div>
            </Col>
            <Col lg={6}>
              <FeatureCopy>
                <SectionHeadText style={{ marginBottom: "20px" }}>
                  Participate in learner communities and turbocharge your learning experience
                </SectionHeadText>
                <SectionBodyText style={{ marginBottom: "28px" }}>
                  Connect with learners like you in your location to share ideas, insights, challenges, and wins
                </SectionBodyText>
                <div className="d-flex align-items-center feature-cta">
                  <Link to="/coming-soon" style={{ textDecoration: "none" }}>
                    <Button className="btn-primary-custom">
                      Get Started
                    </Button>
                  </Link>
                  <BsArrowRightCircle className="spin ms-3" style={{ color: "var(--primary-color)", fontSize: "24px" }} />
                </div>
              </FeatureCopy>
            </Col>
          </Row>
        </FeatureSection>
        )}

        <Container fluid style={{ background: "#F5FFFC", padding: "48px 0" }}>
          <TestimonialCarousel />
        </Container>

        <FaqHeading id="faqs">FAQs</FaqHeading>
        <Accordion activeTab={activeTab} />

        <NewsletterWrap fluid>
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
              <div className="rounded shadow-sm" style={{ background: "var(--primary-color)", color: "white", padding: "24px 20px" }}>
                <Form className="d-md-flex align-items-center gap-3" onSubmit={handleNewsletterJoin}>
                  <div className="flex-grow-1 text-md-start text-center mb-3 mb-md-0">
                    <h5 style={{ fontWeight: 700, margin: "0 0 8px" }}>
                      Get updates
                    </h5>
                    <p style={{ margin: 0, fontSize: "14px", opacity: 0.9 }}>
                      Receive information, new releases and much more directly
                      to your inbox
                    </p>
                  </div>
                  <div className="mb-3 mb-md-0" style={{ minWidth: 0, flex: "0 1 240px" }}>
                    <Form.Group controlId="email">
                      <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        value={newsletterEmail}
                        onChange={e => setNewsletterEmail(e.target.value)}
                        style={{ padding: "10px 16px", borderRadius: "8px" }}
                      />
                    </Form.Group>
                  </div>
                  <div style={{ flex: "0 0 auto" }}>
                    <Button
                      type="submit"
                      className="w-100"
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: "var(--color-primary-700)",
                        borderColor: "var(--color-primary-700)",
                        color: "#fff",
                      }}
                    >
                      Subscribe
                    </Button>
                  </div>
                </Form>
                {newsletterSuccess && (
                  <div className="w-100 text-center mt-2" style={{ color: "#fff" }}>
                    Thank you for joining our newsletter!
                  </div>
                )}
                {newsletterError && (
                  <div className="w-100 text-center mt-2" style={{ color: "#ffd6d6" }}>
                    {newsletterError}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </NewsletterWrap>
      </main>

      {/* Footer start */}

      <AppFooter />
      {/* Footer end */}
    </>
  );
}
